import React from 'react';

import { connectServerSideProps } from '@src/store';
import ssrSpacesListing from '@src/containers/SpacesListing/reducers/listingSSR';
import ssrSession from '@src/containers/Session/reducers/runSSR';
import LayoutBaseCDefault from '@src/components/LayoutBase/connectors/default';
import ListingPageCDefault from '@src/components/ListingPage/connectors/default';
import getSessionCtx from '@src/libs/utils/getSessionCtx';
import { useLoadSpacesWatcher } from '@src/containers/SpacesListing/hooks/useLoadSpaces';
import MapLayerCSpaces from '@src/components/MapLayer/connectors/spaces';
import { useActions as useMapActions } from '@src/containers/Map/hooks';
import PopupCFilters from '@src/components/Popup/set/filters';
import PopupCHeaderSearch from '@src/components/Popup/set/headerSearch';
import fetchTitles from '@src/containers/Session/reducers/fetchTitles';
import SeoHeadCDefault from '@src/components/SeoHead/connectors/default';
import PopupCChoiceClaim from '@src/components/Popup/set/choiceClaim';
import PopupCSpaceConfirm from '@src/components/Popup/set/spaceConfirm';
import PopupCSpaceDeny from '@src/components/Popup/set/spaceDeny';
import getRouterCtx from '@src/containers/Session/selectors/getRouterCtx';

const SpacesList = () => {
	useLoadSpacesWatcher();
	const { openMapInListing } = useMapActions();

	const handleClickMap = React.useCallback(() => {
		openMapInListing();
	}, [openMapInListing]);

	return (
		<>
			<SeoHeadCDefault />
			<LayoutBaseCDefault onClickMap={handleClickMap}>
				<ListingPageCDefault />
			</LayoutBaseCDefault>
			<MapLayerCSpaces />
			<PopupCHeaderSearch />
			<PopupCFilters />
			<PopupCChoiceClaim />
			<PopupCSpaceConfirm />
			<PopupCSpaceDeny />
		</>
	);
};

export const getServerSideProps = connectServerSideProps(
	(store) => async (ctx) => {
		const { dispatch, getState } = store;
		await dispatch(ssrSession.action(getSessionCtx(ctx)));
		const result = await dispatch(ssrSpacesListing.action());

		if (result?.payload?.redirect) {
			return result.payload;
		}
		if (result?.payload?.notFound) {
			return { notFound: true };
		}
		const routerCtx = getRouterCtx(getState());
		const hasQuery =
			routerCtx.query && Object.keys(routerCtx.query).length > 0;

		await dispatch(
			fetchTitles.action({
				type: !hasQuery ? 'listing_root' : 'listing_space',
			}),
		);

		return {};
	},
);

export default SpacesList;
